function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'rust': 'rgb(204, 96, 45)','camel': 'rgb(174, 116, 58)','bubblegum': 'rgb(229, 115, 149)','bubble-gum': 'rgb(229, 115, 149)','cream': 'rgb(227, 222, 209)','sage-green': 'rgb(169, 201, 155)','berry': 'rgb(184, 51, 142)','mint': 'rgb(112, 243, 183)','taupe': 'rgb(227, 193, 163)','sage': 'rgb(128, 180, 151)','baby-blue': 'rgb(163, 250, 250)','burgundy': 'rgb(74, 0, 0)','baby-pink': 'rgb(250, 182, 213)','cognac': 'rgb(191, 108, 57)','orchid': 'rgb(211, 59, 142)','brick': 'rgb(127, 32, 11)','oatmeal': 'rgb(255, 248, 240)','charcoal': 'rgb(68, 68, 68)','mocha': 'rgb(167, 141, 100)','merlot': 'rgb(92, 25, 17)','forest': 'rgb(30, 70, 12)','terra-cotta': 'rgb(180, 130, 36)','ash': 'rgb(78, 73, 79)','eggplant': 'rgb(108, 68, 135)','neon-hot-pink': 'rgb(248, 1, 233)','hunter-green': 'rgb(33, 79, 39)','viva-magenta': 'rgb(249, 48, 127)','blush-mocha': 'rgb(202, 182, 199)','candy-pink': 'rgb(249, 114, 166)','ash-pink': 'rgb(225, 147, 179)','ash-black': 'rgb(62, 57, 57)','coral-fuchsia': 'rgb(242, 56, 105)','mauve': 'rgb(255, 145, 183)','spring-blue': 'rgb(76, 229, 250)','kelly-green': 'rgb(34, 187, 67)','apricot': 'rgb(236, 169, 54)','light-mocha': 'rgb(185, 169, 144)','sand-beige': 'rgb(227, 210, 183)','cinnamon': 'rgb(135, 89, 68)','deep-camel': 'rgb(138, 95, 87)','jade': 'rgb(49, 102, 100)','chocolate': 'rgb(105, 66, 15)','ecru': 'rgb(245, 228, 208)','wine': 'rgb(166, 17, 17)','ash-jade': 'rgb(168, 191, 177)','forrest': 'rgb(45, 107, 67)',};

    this.images = {'rainbow': 'url("//shopsavageroots.com/cdn/shop/files/Rainbow_68x.png?v=342713965165969214")','leopard': 'url("//shopsavageroots.com/cdn/shop/files/Leopard_68x.jpg?v=110827")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
